<template>
    <div class="bg-light p-3 mt-3 sidebar-sub-container" id="vehicleDetails">
        <h3 class="sidebar-sub-container-headline">{{ $t('vue.checkout.sidebar.vehicleDetails.yourCar') }}</h3>
        <p class="sidebar-sub-container-body mb-2 vehicle-title">
          {{ vehicleTitle}}
        </p>
      <ul class="li-checkmark">
          <li>
              {{ $t('vue.checkout.sidebar.vehicleDetails.initialRegistration') }} {{ firstRegistration }}
        </li>
        <li>
            {{ $t('vue.checkout.sidebar.vehicleDetails.drive') }} {{ $t('vehicle.gearshift.'+vehicle.gearshift.slug)}}
        </li>
        <li>
            {{ $t('vue.checkout.sidebar.vehicleDetails.engine', {ps: Math.round(vehicle.power_kw * 1.35962)}) }} 
        </li>
        <li>
            {{ $t('vue.checkout.sidebar.vehicleDetails.fuel') }} {{ $t('vehicle.fuels.'+vehicle.fuel.slug)}}
        </li>
      </ul>
    </div>
</template>

<script>
    export default {
        name: "VehicleDetails",
        props: {
            vehicle: {
                type: Object,
                required: true
            },
            subscription: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                brand: {},
                model: {}
            };
        },

      computed: {
        firstRegistration() {
          let date = new Date(this.vehicle.first_registration)

          return date.toLocaleDateString()
        },
        vehicleTitle() {
          return this.vehicle.brand.title + " " + this.vehicle.model.title + " " + this.vehicle.description
        }
      }

    }
</script>

<style scoped lang="scss">
    .noIconSpacing {
        flex: 0;
    }

    .vehicle-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
</style>
